
import axios from "axios";
import ApiService from "@/services/ApiService.js";

export const state = {
  fechasEntregasInformes:[],
};
export const mutations = {
    FILL_FECHAS_ENTREGAS_INFORMES({ context }, listFechasEntregas) {
        let lista_entregas = [];
        if (listFechasEntregas) {
          Object.entries(listFechasEntregas).forEach(([key, val]) => lista_entregas.push(val));
          return (state.fechasEntregasInformes = lista_entregas);
        }
    }
};
export const actions = {
    //con ests action se comsume el api para saber cuales son las fechas de entregas de informes de un perido
    //por cada cuatrimestre
    //periodo: 1 cuatrimestre 1: fecha_inicial: 2020-08-03 fecha final: 2020-08-07
    GET_FECHAS_ENTREGAS_INFORMES({ commit }, data) {
        return new Promise((resolve, reject) => {
          commit("SET_LOADING", true);
          ApiService.get(data)
            .then(response => {
                // console.log("reposnse de fechas entregas",response.data.data.cuatrimestres)
              commit("SET_LOADING", false);
              commit("FILL_FECHAS_ENTREGAS_INFORMES", response.data.data.cuatrimestres);
              resolve(response);
            })
            .catch(error => {
              commit("SET_LOADING", false);
              reject(error);
            });
        });
      },
      SAVE_DICTAMEN({ commit }, data) {
          return new Promise((resolve, reject) => {
            commit("SET_LOADING", true);
            ApiService.post(data)
              .then(response => {
                // console.log("reposnsede save dictamen", response)
                commit("SET_LOADING", false);
                resolve(response);
              })
              .catch(error => {
                commit("SET_LOADING", false);
                reject(error);
              });
          });
        },
        DELETE_DICTAMEN({ commit }, data) {
          return new Promise((resolve, reject) => {
            commit("SET_LOADING", true);
            ApiService.delete(data)
              .then(response => {
                commit("SET_LOADING", false);
                resolve(response);
              })
              .catch(error => {
                commit("SET_LOADING", false);
                reject(error);
              });
          });
        },
        UPDATE_DICTAMEN({ commit }, data) {
          return new Promise((resolve, reject) => {
            commit("SET_LOADING", true);
            ApiService.put(data)
              .then(response => {
                commit("SET_LOADING", false);
                resolve(response);
              })
              .catch(error => {
                commit("SET_LOADING", false);
                reject(error);
              });
          });
        },
    GET_DICTAMENES({ commit }, data) {
        return new Promise((resolve, reject) => {
          commit("SET_LOADING", true);
          ApiService.get(data)
            .then(response => {
                // console.log("reposnse de fechas entregas",response.data.data.cuatrimestres)
              commit("SET_LOADING", false);
              resolve(response);
            })
            .catch(error => {
              commit("SET_LOADING", false);
              reject(error);
            });
        });
      },

      GET_PDF({ commit }, data) {
          return new Promise((resolve, reject) => {
            commit("SET_LOADING", true);
            ApiService.getPdf(data)
              .then(response => {
                  // console.log("reposnse de fechas entregas",response.data.data.cuatrimestres)
                commit("SET_LOADING", false);
                resolve(response);
              })
              .catch(error => {
                commit("SET_LOADING", false);
                reject(error);
              });
          });
        },

        GET_EXCEL({ commit }, data) {
          // console.log(data);
            return new Promise((resolve, reject) => {
              commit("SET_LOADING", true);
              ApiService.getExcel(data)
                .then(response => {
                    // console.log("reposnse de fechas entregas",response.data.data.cuatrimestres)
                  commit("SET_LOADING", false);
                  resolve(response);
                })
                .catch(error => {
                  commit("SET_LOADING", false);
                  reject(error);
                });
            });
          },

      TERMINAR_INFORME({ commit }, data) {
        return new Promise((resolve, reject) => {
          commit("SET_LOADING", true);
          ApiService.put(data)
          .then(response => {
            commit("SET_LOADING", false);
            resolve(response);
          })
          .catch(error => {
            commit("SET_LOADING", false);
            reject(error);
          });
        });
      }
};

export const getters = {
  fechasEntregasInformes: state => state.fechasEntregasInformes,
};
